export enum StatusModulo {
  attivato = 'ATTIVATO', // in completamento il docente lo deve attivare per assegnare il modulo agli studenti della classe
  inValutazione = 'IN_VALUTAZIONE', // il docente ha assegnato il modulo e deve valutare la classe
  completato = 'COMPLETATO', // il docente ha completato la valutazione della classe
  daAttivare = 'DA_ATTIVARE' // quando il docente clicca su attiva
}
